// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.i1D_NRT0UMAsn9epcBMG{align-items:center;gap:12px;width:283px;padding:8px 12px;display:flex}.Lre5crIf4jA1Gdwk0GW9{gap:8px;display:flex}.jyPlgslyk_EW1YZZfGmk{background:var(--border-neutral-default);width:1px;height:24px}.EkUHYhAmV0tOYx8pmeau input{color:var(--yellow-90)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `i1D_NRT0UMAsn9epcBMG`,
	"left": `Lre5crIf4jA1Gdwk0GW9`,
	"divider": `jyPlgslyk_EW1YZZfGmk`,
	"warnInput": `EkUHYhAmV0tOYx8pmeau`
};
export default ___CSS_LOADER_EXPORT___;
